import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { RecordCategory } from './members/records/RecordCategory.js';
export class OrganizationLevelRecordsConfiguration extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.recordCategories = [];
    }
    getEnabledCategories(organization) {
        return this.recordCategories.filter(category => category.isEnabled(organization));
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(RecordCategory) })
], OrganizationLevelRecordsConfiguration.prototype, "recordCategories", void 0);
//# sourceMappingURL=OrganizationLevelRecordsConfiguration.js.map